module.exports = __webpack_public_path__ + "img/events.c81cdc4c.svg";